import clsx from 'clsx';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { Button } from 'src/general/components/Button/Button';
import { IconArrowLeft } from 'src/general/Icons/IconArrowLeft';
import { getSectionClasses } from 'src/hygiene/sections/flexible-content/getSectionClasses.helper';
import styles from './ProductGridSection.module.scss';

type Props = Prettify<PropsWithChildren & { className?: string; title: string; action?: ReactNode; hrefBack?: string }>;

export const ProductGridSection: FC<Props> = ({ children, className, title, hrefBack, action }) => {
  return (
    <section className={clsx(styles.root, className, 'header-transparent', getSectionClasses('sand'))}>
      <header className={clsx(styles.header, 'header-wrapper')}>
        <div>
          {hrefBack && (
            <Button startIcon={<IconArrowLeft />} href={hrefBack} variant="tertiary">
              Back
            </Button>
          )}
          <h1 className={clsx('c-fs-h4', 'font-extrabold')}>{title}</h1>
        </div>
        <div className={styles.actionContainer}>{action}</div>
      </header>
      {children}
    </section>
  );
};
